import createIcon from '../../createIcon';

/**
 * @component @name Hotel
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyAxMi41QzguNjYgMTIuNSAxMCAxMS4xNiAxMCA5LjVDMTAgNy44NCA4LjY2IDYuNSA3IDYuNUM1LjM0IDYuNSA0IDcuODQgNCA5LjVDNCAxMS4xNiA1LjM0IDEyLjUgNyAxMi41Wk0xOSA2LjVIMTFWMTMuNUgzVjQuNUgxVjE5LjVIM1YxNi41SDIxVjE5LjVIMjNWMTAuNUMyMyA4LjI5IDIxLjIxIDYuNSAxOSA2LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Hotel = createIcon('Hotel', [
  [
    'path',
    {
      d: 'M7 12.5C8.66 12.5 10 11.16 10 9.5C10 7.84 8.66 6.5 7 6.5C5.34 6.5 4 7.84 4 9.5C4 11.16 5.34 12.5 7 12.5ZM19 6.5H11V13.5H3V4.5H1V19.5H3V16.5H21V19.5H23V10.5C23 8.29 21.21 6.5 19 6.5Z',
      key: '12bzoa',
    },
  ],
]);

export default Hotel;
